import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Quote } from "lucide-react";

export default function Testimonials() {
  const [items, setItems] = useState([]);

  useEffect(() => {
    api
      .get("/testimonials")
      .then((r) => setItems(r.data))
      .catch(() => setItems([]));
  }, []);

  return (
    <section
      id="testimonianze"
      data-testid="testimonials-section"
      className="py-24 sm:py-32 bg-graphite-900/40"
    >
      <div className="container-x">
        <div className="max-w-3xl mb-16">
          <div className="overline mb-4">Cosa dicono i clienti</div>
          <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl font-medium tracking-tighter">
            Fiducia costruita
            <br />
            <span className="text-white/40">un progetto alla volta.</span>
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {items.map((t) => (
            <blockquote
              key={t.id}
              data-testid={`testimonial-${t.id}`}
              className="relative p-8 rounded-xl border border-white/10 bg-graphite-900 hover:border-white/25 transition-all"
            >
              <Quote strokeWidth={1.5} className="w-8 h-8 text-gold mb-6" />
              <p className="text-white/85 leading-relaxed text-lg">&ldquo;{t.quote}&rdquo;</p>
              <footer className="mt-8 flex items-center gap-3 pt-6 border-t border-white/10">
                <img src={t.avatar} alt={t.name} className="w-10 h-10 rounded-full object-cover" />
                <div>
                  <div className="text-sm font-medium">{t.name}</div>
                  <div className="text-xs text-white/50">{t.role}</div>
                </div>
              </footer>
            </blockquote>
          ))}
        </div>
      </div>
    </section>
  );
}
